<mat-card class="thin-card">
  <mat-card-title>
    Forgot Password
  </mat-card-title>

  <form #forgotPasswordForm="ngForm" class="example-form">
    <div fxLayout="row">
      <div fxFlex.xs="100%" fxFlex="95%">
        <div fxLayout="column">
          <mat-form-field class="mam-full-width">
            <input matInput placeholder="Email" [(ngModel)]="email" name="email" required />
          </mat-form-field>

          <div fxFlex>
            <div fxLayout="row wrap" fxLayoutAlign="space-between center">
              <button
                fxFlex.xs="100%"
                fxFlex="30%"
                [disabled]="!forgotPasswordForm.form.valid"
                mat-raised-button
                (click)="forgotPassword()"
                type="submit"
                color="primary"
              >
                Submit
              </button>
              <button fxFlex.xs="100%" fxFlex="30%" mat-button (click)="cancel()" type="button" color="primary">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-card>
